const { Core, Utils } = Global;
const { $state, setDocumentClickHandler } = Utils;

const ATTR_DROP_OPTION = 'data-dropdown-option';

customElements.define('drop-down', class extends Core {
    propTypes = {
        'close-on-change': Boolean,
        'update-value': Boolean
    }

    elements = {
        $: ['selected-value', 'select', 'details']
    }

    render() {
        this._toggleDocClickListener = setDocumentClickHandler(this._handleOuterClick.bind(this));
        this.$({
            change: this._handleChange
        })
        
        this.$('select', {
            change: this._handleSelectChange
        })
        this.$('details', {
            toggle: this._handleDetailsToggle
        })
    }

    _handleDetailsToggle() {
        this._toggleDocClickListener(this.$('details').open)
    }

    _handleChange(e) {
        const target = e.target;
        if(target.hasAttribute(ATTR_DROP_OPTION)) {
            e.stopPropagation();
            this._updateSelect(target.value);

            if(this.prop('close-on-change')) {
                this.close();
            }
        }
    }

    _handleOuterClick(e) {
        if(this.contains(e.target)) {
            return;
        } 
        this.close();
    }

    _updateSelect(value) {
        if(this.$('select')) {
            this.$('select').value = value;
            this.$('select').dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
    }

    _handleSelectChange(e) {
        if(this.prop('update-value') && this.$('selected-value')) {
            this.$('selected-value').innerText = e.target.options[e.target.selectedIndex].text;
        }

        const is_products_to_show = e.target.name == 'products_to_show' ? true : false;
          
          if(is_products_to_show) {
            e.preventDefault();

           let value = e.target.value * 1;
            

               fetch("".concat(window.dynamicURLs.cart, "/update.js"), {
            body: JSON.stringify({
            attributes: {
              'collection_products_per_page': value
            }
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
 
          }
        }).then(function (response) {
        location.reload();
        });
    }
    }

    close() {
        this.open = false;
    }

    destroy() {
        this._toggleDocClickListener(false);
    }

    set open(state) {
        this.$('details').open = state;
    }
});